// Lib
import { ListingUI } from 'features/Dealers/Listings/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { UIDepartments, EngineLocations, UIDepartment } from './types';

export interface ActionGetLMDepartmentsAPI extends Action {
    idengine?: string
    iddealer?: string
}

export const getLMDepartmentsAPI = (idengine?: string, iddealer?: string): ActionGetLMDepartmentsAPI => ({
    type: ACTIONS.GET_LMDEPARTMENTS_API_REQUEST,
    idengine,
    iddealer
});

export interface ActionGetLMDepartmentsAPISuccess extends Action {
    departments: UIDepartments
}

export const getLMDepartmentsAPISuccess = (departments: UIDepartments): ActionGetLMDepartmentsAPISuccess => ({
    type: ACTIONS.GET_LMDEPARTMENTS_API_SUCCESS,
    departments
});

export const getLMDepartmentsAPIError = (error: any): Action => ({
    type: ACTIONS.GET_LMDEPARTMENTS_API_ERROR,
});


export interface ActionPostListing extends Action {
    dealerId: string
    engineId: string
    department: UIDepartment[]
}

export const postListingAPI = (engineId: string, dealerId: string, department: UIDepartment[]): ActionPostListing => ({
    type: ACTIONS.POST_LISTINGS_API_REQUEST,
    engineId,
    dealerId,
    department
});

export interface ActionPostListingSuccess extends Action {
    listings: ListingUI[],    
    departments: UIDepartment[]
}

export const postListingSuccess = (listings: ListingUI[], departments:UIDepartment[]): ActionPostListingSuccess => ({
    type: ACTIONS.POST_LISTINGS_API_SUCCESS,
    listings,
    departments
});

export const postListingError = (): Action => ({
    type: ACTIONS.POST_LISTINGS_API_ERROR,
});


export interface ActionEditLMDepartments extends Action {
    departments: UIDepartment[]
}

export const editLiveDepartments = (departments: UIDepartment[]): ActionEditLMDepartments => ({
    type: ACTIONS.EDIT_LIVE_DEPARTMENTS,
    departments
});

export interface ActionGetEngineLocationsAPI extends Action {
    engineId: string
    dealerId: string
}

export const getEngineLocationsAPI = (engineId: string, dealerId: string): ActionGetEngineLocationsAPI => ({
    type: ACTIONS.GET_ENGINELOCATIONS_API_REQUEST,
    engineId,
    dealerId
});

export interface ActionGetEngineLocationsAPISuccess extends Action {
    engineLocations: EngineLocations
}

export const getEngineLocationsAPISuccess = (engineLocations: EngineLocations): ActionGetEngineLocationsAPISuccess => ({
    type: ACTIONS.GET_ENGINELOCATIONS_API_SUCCESS,
    engineLocations
});

export const getEngineLocationsAPIError = (): Action => ({
    type: ACTIONS.GET_ENGINELOCATIONS_API_ERROR,
});

